import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CdnIcon } from "../../CdnIcon/index.js";
import { P } from "../../Text/index.js";
import { A } from "../../A/index.js";
import { Button } from "../../Button/index.js";
import { DEFAULT_MAX_TRAVELERS } from "../constants.js";
function MaxRoomsBannerMessage({ maxRoomsMessage, maxRoomsUrl, fireMaxRoomsOnClick, maxRooms = DEFAULT_MAX_TRAVELERS }) {
    const defaultMaxRoomsMessage = `You may only book up to ${maxRooms} rooms.`;
    function onMaxRoomsBannerClick() {
        if (fireMaxRoomsOnClick) fireMaxRoomsOnClick();
    }
    const MaxRoomsNode = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            maxRooms + 1,
            " Rooms or More ",
            /*#__PURE__*/ jsx(CdnIcon, {
                iconName: "arrow_forward"
            })
        ]
    });
    return /*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsxs(P, {
                children: [
                    " ",
                    maxRoomsMessage ?? defaultMaxRoomsMessage
                ]
            }),
            maxRoomsUrl && !fireMaxRoomsOnClick ? /*#__PURE__*/ jsx(A, {
                type: "tertiary",
                className: "justify-start",
                href: maxRoomsUrl,
                target: "_blank",
                children: MaxRoomsNode
            }) : null,
            fireMaxRoomsOnClick ? /*#__PURE__*/ jsx(Button, {
                type: "tertiary",
                className: "flex items-center",
                onClick: onMaxRoomsBannerClick,
                children: MaxRoomsNode
            }) : null
        ]
    });
}
export { MaxRoomsBannerMessage };
